module.exports = __webpack_public_path__ + "static/media/loadingGif.ded6daf3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/gifs/loadingGif.gif
// module id = 570
// module chunks = 0